export default __webpack_public_path__ + "static/media/success5.png";